export default __webpack_public_path__ + "static/media/logo-final-cem.79d1bdaf.svg";